<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item
        ><router-link to="/">首页</router-link></el-breadcrumb-item
      >
      <el-breadcrumb-item>测评记录</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <el-form
        inline
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="selClick"
      >
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item label="学历">
          <el-select
            v-model="edu"
            clearable
            placeholder="选择学历"
            style="width: 200px"
            @change="selClick()"
          >
            <el-option
              v-for="item in edulist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="用户">
          <el-select
            v-model="userid"
            clearable
            placeholder="选择用户"
            style="width: 200px"
            @change="selClick()"
          >
            <el-option
              v-for="item in userlist"
              :key="item.id"
              :label="item.nickName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick">查询</el-button>
        </el-form-item>
      </el-form>
      <el-card class="box-card table">
        <div slot="header"><span>记录列表</span></div>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column
            prop="wxUser.code"
            label="用户编号"
            min-width="60"
          ></el-table-column>
          <el-table-column
            prop="wxUser.nickName"
            label="用户"
            min-width="60"
          ></el-table-column>
          <el-table-column
            prop="weChat"
            label="微信"
            min-width="60"
          ></el-table-column>
          <el-table-column
            prop="qualificationName"
            label="学历"
            min-width="60"
          ></el-table-column>
          <el-table-column
            prop="startTime"
            label="开始时间"
            width="170"
          ></el-table-column>
          <el-table-column
            prop="endTime"
            label="结束时间"
            width="170"
          ></el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="查看" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-thumb"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top:20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total,prev,sizes,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 查看测评记录弹框 -->
    <el-dialog
      title="测评记录详情"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="80%"
      top="5vh"
    >
      <!-- <div v-loading="loading"> -->
      <div class="detail-section">
        <div class="section-title">
          <i class="el-icon-user"></i>
          基本信息
        </div>

        <div class="detail-grid">
          <div class="detail-item">
            <div class="detail-label">会员编号</div>
            <div class="detail-value" v-if="form.wxUser">
              {{ form.wxUser.code || "-" }}
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-label">昵称</div>
            <div class="detail-value" v-if="form.wxUser">
              {{ form.wxUser.nickName || "-" }}
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-label">微信</div>
            <div class="detail-value">
              {{ form.weChat || "-" }}
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-label">学历</div>
            <div class="detail-value">
              {{ form.qualificationName || "-" }}
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-label">开始时间</div>
            <div class="detail-value">
              {{ form.startTime || "-" }}
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-label">提交时间</div>
            <div class="detail-value">
              {{ form.endTime || "-" }}
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-label">结果类型</div>
            <div class="detail-value" v-if="form.category">
              {{ form.category.title || "-" }}({{ form.category.code || "-" }})
            </div>
          </div>

          <div class="detail-item detail-item-full">
            <div class="detail-label">特点描述</div>
            <div class="detail-value detail-text" v-if="form.category">
              {{ form.category.result || "-" }}
            </div>
          </div>

          <div class="detail-item detail-item-full">
            <div class="detail-label">推荐专业</div>
            <div class="detail-value detail-text" v-if="form.category">
              {{ form.category.major || "-" }}
            </div>
          </div>

          <div class="detail-item detail-item-full">
            <div class="detail-label">推荐职业方向</div>
            <div class="detail-value detail-text" v-if="form.category">
              {{ form.category.work || "-" }}
            </div>
          </div>
        </div>
         <!-- 各类型得分区域 - 新增 -->
         <div class="detail-section score-section" v-if="scoreList.length > 0">
          <div class="section-title">
            <i class="el-icon-pie-chart"></i>
            各类型得分
            <span class="plan-count"> 共 {{ scoreList.length }} 个维度 </span>
          </div>

          <div class="score-grid">
            <div
              v-for="(score, index) in scoreList"
              :key="score.id || index"
              class="score-item"
            >
              <div class="score-header">
                <span class="score-name">{{ score.name || "维度" + (index + 1) }}</span>
                <span class="score-value">{{ score.score || 0 }}</span>
              </div>
              <!-- <el-progress
                :percentage="getScorePercentage(score.score)"
                :color="getScoreColor(score.score)"
                :stroke-width="12"
                :show-text="false"
              ></el-progress> -->
              <div class="score-detail" v-if="score.description">
                {{ score.description }}
              </div>
            </div>
          </div>
        </div>
        <!-- 留学方案 -->
        <div class="detail-section plan-section">
          <div class="section-title">
            <i class="el-icon-document"></i>
            留学方案
            <span class="plan-count"> 共 {{ planList.length }} 个方案 </span>
          </div>

          <div v-if="planList.length > 0" class="plan-list">
            <el-card
              v-for="(plan, index) in planList"
              :key="plan.id || index"
              class="plan-card"
              shadow="hover"
            >
              <div slot="header" class="plan-header">
                <div class="plan-title">
                  <span class="plan-number">{{ index + 1 }}</span>
                  {{ plan.title || "未命名方案" }}
                </div>
              </div>

              <div class="plan-content">
                <div class="plan-info-row">
                  <div class="plan-info-label">选择比例</div>
                  <div class="plan-info-value">
                    {{ plan.ratio || "-" }}
                  </div>
                </div>

                <div class="plan-info-row">
                  <div class="plan-info-label">适合人群</div>
                  <div class="plan-info-value">
                    {{ plan.people || "-" }}
                  </div>
                </div>

                <div class="plan-info-row">
                  <div class="plan-info-label">学习规划</div>
                  <div class="plan-info-value">
                    {{ plan.stuPlan || "-" }}
                  </div>
                </div>

                <div
                  v-if="plan.timeNode"
                  class="plan-info-row plan-content-row"
                >
                  <div class="plan-info-label">时间节点</div>
                  <div class="plan-info-value plan-description">
                    {{ plan.timeNode }}
                  </div>
                </div>

                <!-- 额外显示其他可能存在的字段 -->
                <div
                  v-if="plan.content"
                  class="plan-info-row plan-content-row"
                >
                  <div class="plan-info-label">内容详情</div>
                  <div class="plan-info-value plan-description">
                    {{ plan.content }}
                  </div>
                </div>

                <div
                  v-if="plan.result"
                  class="plan-info-row plan-content-row"
                >
                  <div class="plan-info-label">预期结果</div>
                  <div class="plan-info-value plan-description">
                    {{ plan.result }}
                  </div>
                </div>

                <div
                  v-if="plan.description"
                  class="plan-info-row plan-content-row"
                >
                  <div class="plan-info-label">方案描述</div>
                  <div class="plan-info-value plan-description">
                    {{ plan.description }}
                  </div>
                </div>

                <div
                  v-if="plan.plan"
                  class="plan-info-row plan-content-row"
                >
                  <div class="plan-info-label">详细规划</div>
                  <div class="plan-info-value plan-description">
                    {{ plan.plan }}
                  </div>
                </div>
              </div>
            </el-card>
          </div>

          <div v-else class="empty-plan">
            <i class="el-icon-document"></i>
            <div>暂无留学方案</div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      key: "",
      userid: "",
      edu: "",
      loading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      submiting: false,
      form: {},

      userlist: [],
      edulist: [],
      planList: [],
      scoreList: [], // 各类型得分列表
    };
  },
  created() {
    this.GetAllUser();
    this.GetList_Qualiafication();
    this.getList();
  },
  methods: {
    api(a) {
      return url.getMiniCategoryAndStudyPlan(a);
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    selClick() {
      this.currentPage = 1;
      this.getList();
    },
    GetList_Qualiafication: function() {
      var _this = this;
      var link = this.api("GetList_Qualiafication");
      $.get(link, {}, (res) => {
        _this.edulist = res;
      });
    },
    GetAllUser: function() {
      var _this = this;
      var link = this.api("GetAllUser");
      $.get(link, {}, (res) => {
        _this.userlist = res;
      });
    },
    getList() {
      this.loading = true;
      $.get(
        this.api("GetList_EvaRecord"),
        {
          key: this.key,
          userid: this.userid,
          edu: this.edu,
          pageindex: this.currentPage,
          pagesize: this.pageSize,
        },
        (data) => {
          this.loading = false;
          this.tableData = data.list;
          this.total = data.total;
        }
      );
    },
    addClick() {
      this.form = {};
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    editClick(row) {
      // this.form = Object.assign({}, row);
      // this.dialogVisible = true;
      var _this = this;
      var id = row.id;
      var link = this.api("GetModel_EvaRecord");
      $.get(link, { id: id }, (res) => {
        _this.form = res.model;
        _this.planList = res.planList;
        _this.scoreList = JSON.parse(res.model.scoreDetail)
        console.log(_this.form);

        _this.dialogVisible = true;
      });
    },
    delClick(row) {
      this.$confirm("确定删除？", "提示", { type: "warning" })
        .then(() => {
          $.post(this.api("Delete_EvaRecord"), { id: row.id }, (res) => {
            if (res.status) {
              this.getList();
              this.$message.success(res.msg);
            } else this.$message.error(res.msg);
          });
        })
        .catch(() => {});
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const info = Object.assign({}, this.form);
        this.submiting = true;
        $.post(this.api("Save_Question"), info, (res) => {
          this.submiting = false;
          if (res.status) {
            this.dialogVisible = false;
            this.getList();
            this.$message.success(res.msg);
          } else this.$message.error(res.msg);
        });
      });
    },
  },
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
/* 基本信息区域样式 */
.detail-section {
  background: #f8f9fc;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  padding-bottom: 15px;
  border-bottom: 2px solid #e8ecf1;
  margin-bottom: 20px;
}

.section-title i {
  color: #409eff;
  margin-right: 8px;
}

.plan-count {
  font-size: 13px;
  font-weight: normal;
  color: #909399;
  margin-left: 10px;
}

/* 网格布局 - 显示两列 */
.detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 30px;
}

/* 每个信息项 */
.detail-item {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  border-bottom: 1px solid #f0f2f5;
}

/* 占满整行的项 */
.detail-item-full {
  grid-column: 1 / -1;
}

/* 标签样式 */
.detail-label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 6px;
  font-weight: 500;
}

/* 值样式 */
.detail-value {
  font-size: 14px;
  color: #2c3e50;
  word-break: break-all;
  min-height: 22px;
}

/* 文本内容（用于较长的描述） */
.detail-text {
  line-height: 1.8;
  background: #f5f7fa;
  padding: 10px 14px;
  border-radius: 4px;
  border-left: 3px solid #409eff;
  white-space: pre-wrap;
  color: #303133;
}

/* 空状态提示 */
.empty-plan {
  text-align: center;
  padding: 40px 0;
  color: #909399;
}

.empty-plan i {
  font-size: 48px;
  display: block;
  margin-bottom: 12px;
  color: #dcdfe6;
}

/* 响应式：小屏幕变为单列 */
@media screen and (max-width: 768px) {
  .detail-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .detail-item {
    padding: 6px 0;
  }

  .detail-section {
    padding: 15px;
  }
}

/* 可选：添加卡片悬停效果 */
.detail-item:hover {
  background: #f5f7fa;
  margin: 0 -10px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

/* 美化标签的图标 */
.detail-label::before {
  content: "•";
  color: #409eff;
  margin-right: 6px;
  font-weight: bold;
}

/* 调整全宽项的样式 */
.detail-item-full .detail-value {
  background: #ffffff;
  padding: 10px 14px;
  border-radius: 4px;
  border: 1px solid #e8ecf1;
}

.detail-item-full .detail-value.detail-text {
  background: #f5f7fa;
  border: none;
}

/* 留学方案样式 */
.plan-section {
  background: #ffffff;
  border: 1px solid #e8ecf1;
}

.plan-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.plan-card {
  border-radius: 8px;
  border: 1px solid #e8ecf1;
  transition: all 0.3s ease;
}

.plan-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.plan-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.plan-title {
  font-size: 15px;
  font-weight: 600;
  color: #2c3e50;
}

.plan-number {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background: #409eff;
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  margin-right: 10px;
}

.plan-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.plan-info-row {
  display: flex;
  padding: 4px 0;
}

.plan-info-label {
  width: 80px;
  flex-shrink: 0;
  font-size: 13px;
  color: #909399;
  font-weight: 500;
}

.plan-info-value {
  flex: 1;
  font-size: 14px;
  color: #2c3e50;
  word-break: break-all;
}

.plan-description {
  background: #f8f9fc;
  padding: 10px 14px;
  border-radius: 4px;
  line-height: 1.6;
  white-space: pre-wrap;
}

.plan-content-row {
  flex-direction: column;
}

.plan-content-row .plan-info-label {
  width: 100%;
  margin-bottom: 6px;
}

.plan-content-row .plan-info-value {
  width: 100%;
}

/* 对话框底部按钮样式 */
.dialog-footer {
  padding: 10px 0 0;
}
/* ============ 各类型得分样式 ============ */
.score-section {
  background: linear-gradient(135deg, #f5f9ff 0%, #eef3f8 100%);
  border: 1px solid #d9e5f0;
}

.score-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 30px;
}

.score-item {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  border: 1px solid #e8ecf1;
}

.score-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(64, 158, 255, 0.12);
  border-color: #409eff;
}

.score-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.score-name {
  font-size: 14px;
  color: #2c3e50;
  font-weight: 500;
}

.score-value {
  font-size: 18px;
  font-weight: 700;
  color: #409eff;
  background: #ecf5ff;
  padding: 0 12px;
  border-radius: 12px;
  line-height: 28px;
}

.score-detail {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  padding-top: 8px;
  border-top: 1px dashed #e8ecf1;
}

/* 进度条自定义 */
.score-item .el-progress {
  margin: 6px 0 2px;
}

.score-item .el-progress-bar__outer {
  border-radius: 6px;
  background-color: #f0f2f5;
}

.score-item .el-progress-bar__inner {
  border-radius: 6px;
  transition: width 1s ease;
}
</style>
